module.exports = __webpack_public_path__ + "static/media/cwiczenie_2.1fa734b4.jpg";